import { render } from "./Share.vue?vue&type=template&id=25b26041"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Share.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25b26041"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25b26041', __exports__)) {
    api.reload('25b26041', __exports__)
  }
  
  module.hot.accept("./Share.vue?vue&type=template&id=25b26041", () => {
    api.rerender('25b26041', render)
  })

}


export default __exports__